module.exports = __webpack_public_path__ + "media/assets/images/icons/patient-page/in-other-b44f96b2162905dc97d14ff4e269cf93.svg";